import { render, staticRenderFns } from "./corpusDetailUploadDialog.vue?vue&type=template&id=34348766&scoped=true&"
import script from "./corpusDetailUploadDialog.vue?vue&type=script&lang=js&"
export * from "./corpusDetailUploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./corpusDetailUploadDialog.vue?vue&type=style&index=0&id=34348766&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34348766",
  null
  
)

export default component.exports